import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { agentSetupService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type agentHistoryProps = {
	historyKey: string;
	fetchData: {
		page: number;
	};
	id: number;
};

const useGetAgentHistoryQuery = ({
	historyKey,
	fetchData,
	id,
}: agentHistoryProps) => {
	const dispatch = useDispatch();
	const { page } = fetchData || {};

	return useQuery(
		[historyKey, page],
		() => agentSetupService.getAgentHistory({ page, id }),
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!id,
			cacheTime: 0,
		},
	);
};

export default useGetAgentHistoryQuery;
